import React, {memo, Suspense} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import connect from "./connect"

interface PrimaryNavProps {
    closeNav: (e: any) => void
    mobileHeight: number
    desktopHeight: number
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

export const PrimaryNav = memo(({closeNav, mobileHeight, desktopHeight, templating}: PrimaryNavProps) => {
    const TemplatedNav = useTemplatedComponent(templating, MANIFEST)

    const props = {
        closeNav,
        mobileHeight,
        desktopHeight,
    }

    return (
        <Suspense>
            <TemplatedNav {...props} />
        </Suspense>
    )
})
PrimaryNav.displayName = "PrimaryNav"

export default connect(PrimaryNav)
